const iconRightSmall = props => (
	<svg viewBox="0 0 9 14" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M0.57666 12.4867L1.75666 13.6667L8.42333 7.00004L1.75666 0.333374L0.57666 1.51337L6.06333 7.00004L0.57666 12.4867Z"
			fill="currentColor"
		/>
	</svg>
);
export default iconRightSmall;
